import { register } from './viewbilityTracker'

export function registerExternalScripts() {
  register('.top-posts-side-bar__item')
  register('.riddleEmbedded')
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/viewability/externalScriptsViewabilityRegistration.js